

const currentLocale = mpro.getCurrentLocalesFor(mpro.getCurrentLocale(), 'parsleyjs')[0] || 'en';
const { Parsley } = window;

const validateLettersDigits = (value) => {
	return (/[a-z]/i.test(value) && /\d/i.test(value));
};

const validateLettersDigitsSymbols = (value) => {
	return validateLettersDigits(value) && /[!"#$%&'()*+,./:;<=>?@[\\\]^_`{|}~\-]/i.test(value);
};

/**
 * @deprecated
 */
Parsley.addValidator('passwordFormat', {

	requirementType: 'string',

	/**
	 * @param {string} value
	 * @param {string} requirement
	 */
	validateString: (value, requirement, parsleyInstance) => {

		const { $element } = parsleyInstance;

		// Need letters + digits
		if (requirement === 'letters_digits') {

			// Missing letters and/or digits
			if (validateLettersDigits(value) === false) {

				// Get the label for the input
				let $label = $element.closest(mpro.config.ui.form_row_selector).find('label').filter(`[for="${$element.attr('name')}"]`);
				if ($label.length === 0) {
					$label = $label.end().first();
				}
				const label = $label.text() || '%s';

				// // Replace the message with current input label text
				// Parsley.addMessage(currentLocale, 'passwordFormat', mpro.langvar('error_password_letters_digits', { 'field_label': label }));

				// Let parsley return the custom validator message
				if (Parsley.instanceHasCustomValidatorMessage(parsleyInstance, 'passwordFormat')) {
					return false;
				}

				// Return the default message
				return $.Deferred().reject(mpro.langvar('error_password_letters_digits', { field_label: label }));
			}
		}
		// Need letters + digits + symbols
		else if (requirement === 'letters_digits_symbols') {

			// Missing letters and/or digits and/or symbols
			if (validateLettersDigitsSymbols(value) === false) {

				// Get the label for the input
				let $label = $element.closest(mpro.config.ui.form_row_selector).find('label').filter(`[for="${$element.attr('name')}"]`);
				if ($label.length === 0) {
					$label = $label.end().first();
				}
				const label = $label.text() || '%s';

				// // Replace the message with current input label text
				// Parsley.addMessage(currentLocale, 'passwordFormat', mpro.langvar('error_password_letters_digits_symbols', { 'field_label': label }));

				// Let parsley return the custom validator message
				if (Parsley.instanceHasCustomValidatorMessage(parsleyInstance, 'passwordFormat')) {
					return false;
				}

				// Return the default message
				return $.Deferred().reject(mpro.langvar('error_password_letters_digits_symbols', { field_label: label }));
			}
		}

		return true;
	},

	priority: 32,

	// Note: can only set one message per locale
	messages: {
		[currentLocale]: mpro.langvar('error_password_letters_digits', { field_label: '' }).replaceAll(/\s+/g, ' '),
	},
});

// Redundant validator, but it's here as an example
Parsley.addValidator('passwordFormatLettersDigits', {
	requirementType: 'string',
	/** @param {string} value */
	validateString: validateLettersDigits,
	priority: 32,
	messages: {
		[currentLocale]: mpro.langvar('error_password_letters_digits', { field_label: '' }).replaceAll(/\s+/g, ' '),
	},
});

// Redundant validator, but it's here as an example
Parsley.addValidator('passwordFormatLettersDigitsSymbols', {
	requirementType: 'string',
	/** @param {string} value */
	validateString: validateLettersDigitsSymbols,
	priority: 32,
	messages: {
		[currentLocale]: mpro.langvar('error_password_letters_digits_symbols', { field_label: '' }).replaceAll(/\s+/g, ' '),
	},
});

export {};